"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xss = void 0;
const xss_1 = require("xss");
/**
 * Sanitize untrusted HTML (to prevent XSS).
 *
 * @param str - string to sanitize
 *
 * @returns sanitized string
 *
 * @example
 * ```ts
 * const result = xss('<script>alert("xss")</script>');
 * console.log(result);
 * // => '&lt;script&gt;alert("xss")&lt;/script&gt;
 * ```
 */
function xss(str) {
    return (0, xss_1.filterXSS)(str);
}
exports.xss = xss;
//# sourceMappingURL=xss.js.map